import { useControllerContext } from "../../hooks/controller-context";
import { ControllerTab } from "../../hooks/use-controller-tab";
import { ControllerTabWrapper } from "./style";

const TimerControllerTabs = () => {
  const { isControllerTab, setControllerTab } = useControllerContext();

  const tabs = [
    { name: "토너먼트 정보", value: ControllerTab.TOURNAMENT },
    { name: "타이머 관리", value: ControllerTab.TIMER },
    { name: "싯인 관리", value: ControllerTab.SIT_IN },
    { name: "진행현황", value: ControllerTab.STATUS },
  ];
  return (
    <ControllerTabWrapper>
      {tabs.map((tab, index) => (
        <div
          className={`tab ${
            tab.value && isControllerTab(tab.value) ? "selected" : ""
          }`}
          key={index}
          onClick={() => tab.value && setControllerTab(tab.value)}
        >
          {tab.name}
        </div>
      ))}
    </ControllerTabWrapper>
  );
};

export default TimerControllerTabs;
